import type {RepositoryNWO} from '@github-ui/current-repository'
import {SignedCommitBadge} from '@github-ui/signed-commit-badge'
import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'

import type {CommitExtended} from '../types/commit-types'
import type {DeferredCommitData} from '../types/commits-types'
import {AsyncChecksStatusBadge} from './AsyncChecksStatusBadge'

export function DeferredCommitHeaderData({
  deferredData,
  oid,
  repo,
  helpUrl,
}: {
  deferredData: DeferredCommitData | undefined
  oid: CommitExtended['oid']
  repo: RepositoryNWO
  helpUrl: string
}) {
  const isLoading = deferredData === undefined

  let checkStatusCount = ''
  try {
    checkStatusCount = deferredData?.statusCheckStatus?.short_text?.split('checks')[0]?.trim() || ''
  } catch {
    //noop
  }

  return (
    <>
      {isLoading && <LoadingSkeleton className="ml-2" variant="rounded" width={'62px'} />}
      {deferredData?.statusCheckStatus && (
        <>
          <span className="d-flex ml-2 mr-1">&middot;</span>
          <AsyncChecksStatusBadge
            oid={oid}
            status={deferredData?.statusCheckStatus?.state}
            descriptionString={checkStatusCount}
            repo={repo}
          />

          {deferredData?.signatureInformation && deferredData?.verifiedStatus !== 'unsigned' && (
            <span className="d-flex ml-2">&middot;</span>
          )}
        </>
      )}
      {deferredData?.signatureInformation && (
        <div className="ml-2">
          <SignedCommitBadge
            commitOid={oid}
            hasSignature
            verificationStatus={deferredData.verifiedStatus}
            signature={{helpUrl, ...deferredData.signatureInformation}}
          />
        </div>
      )}
    </>
  )
}
